import {Honorifics, MarkBenevolentFund} from "./mbf";

export function Charity() {
    return <>
        <MarkBenevolentFund/>
        <Honorifics/>
    </>
}